import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ConfigService {
    static configLoaded$ = new ReplaySubject(1);

    private static config: any;

    constructor(private http: HttpClient) {}

    static get(key: string): any {
        return ConfigService.config
            && ConfigService.config[key];
    }

    load() {
       return new Promise((resolve, reject) => {
            this.http.get('./assets/env.json')
                .subscribe({
                    next: (config) => {
                        ConfigService.config = config;
                        ConfigService.configLoaded$.next(true);
                        resolve(true);
                    },
                    error: () => reject()
                });
        });
    }
}
